import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.getPage(slug).then(setPage).catch(() => setErr(true)); }, [slug]);

  return (
    <main className="relative min-h-screen pt-28">
      <div className="mx-auto max-w-5xl px-5 lg:px-8">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-white"><ArrowLeft className="h-4 w-4 rotate-180" /> الرئيسية</Link>
        {!page && !err && <div className="flex h-[50vh] items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-cyan" /></div>}
        {err && <p className="py-24 text-center text-muted-foreground">الصفحة غير موجودة.</p>}
        {page && (
          <div className="mt-6">
            <h1 className="font-display text-4xl font-extrabold text-white">{page.title}</h1>
            <div className="mt-6 overflow-hidden rounded-2xl border border-white/10 bg-white">
              <iframe title={page.title} srcDoc={page.content} className="min-h-[70vh] w-full" />
            </div>
          </div>
        )}
      </div>
      <div className="h-16" />
    </main>
  );
}
